import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance";


export class SurveyAnswerApiService {
    private readonly surveyAnswerBaseUrl: string;

    constructor() {
        this.surveyAnswerBaseUrl = ApiConstants().surveyAnswer;
    }

    async answerQuestion(data: unknown): Promise<AxiosResponse> {
        return request({
            method: "POST",
            url: `${this.surveyAnswerBaseUrl}`,
            requiresToken: true,
            data,
        });
    }

    async modifyAnswer(data: unknown, answerId: string): Promise<AxiosResponse> {
        return request({
            method: "PATCH",
            url: `${this.surveyAnswerBaseUrl}${answerId}`,
            requiresToken: true,
            data,
        });
    }

    async commentSurvey(data: unknown, surveyId: string): Promise<AxiosResponse> {
        return request({
            method: "POST",
            url: `${this.surveyAnswerBaseUrl}survey/${surveyId}/comment`,
            requiresToken: true,
            data,
        });
    }

    async modifySurveyComment(data: unknown, surveyId: string): Promise<AxiosResponse> {
        return request({
            method: "PATCH",
            url: `${this.surveyAnswerBaseUrl}survey/${surveyId}/comment`,
            requiresToken: true,
            data,
        });
    }
}
